import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import env from 'misc/env';
import axios from 'axios';
import auth0 from 'auth0-js';
import TokenCache from '../utils/tokenCacheUtil';
import { AuthTransactionManager } from './AuthTransactionManager';
import { localStorage } from './storage';
import { GenericError, TimeoutError } from '@auth0/auth0-spa-js';
var Auth0Client = /*#__PURE__*/function () {
  function Auth0Client(_ref) {
    var domain = _ref.domain,
      clientId = _ref.clientId,
      audience = _ref.audience,
      redirectUri = _ref.redirectUri;
    _classCallCheck(this, Auth0Client);
    this.domain = domain;
    this.clientId = clientId;
    this.redirectUri = redirectUri;
    this.scope = 'openid profile email offline_access';
    var authParams = {
      domain: domain,
      clientID: clientId,
      audience: audience,
      redirectUri: redirectUri,
      scope: 'openid profile email offline_access'
    };
    this.transactionManager = new AuthTransactionManager();
    this.tokenCache = new TokenCache();
    this.webAuth = new auth0.WebAuth(authParams);
    this.apiAuth = new auth0.Authentication(authParams);
  }

  /**
   * Redirects to /authorize with the specified options.
   *
   * @param {*} opts
   */
  return _createClass(Auth0Client, [{
    key: "loginWithRedirect",
    value: (function () {
      var _loginWithRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
        var challenge;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.transactionManager.create();
            case 2:
              challenge = _context.sent;
              this.webAuth.authorize(_objectSpread(_objectSpread(_objectSpread({}, opts), challenge), {}, {
                responseType: 'code'
              }), function (error, _) {
                if (error) {
                  console.error(error);
                  localStorage.setItem('authError', JSON.stringify(error));
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loginWithRedirect(_x) {
        return _loginWithRedirect.apply(this, arguments);
      }
      return loginWithRedirect;
    }()
    /**
     * Login using an explicit username and password.
     *
     * @param {*} opts
     */
    )
  }, {
    key: "loginWithUsernamePassword",
    value: (function () {
      var _loginWithUsernamePassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                return _this.apiAuth.login(_objectSpread({}, opts), function (error, token) {
                  if (error) {
                    console.error(error);
                    localStorage.setItem('authError', JSON.stringify(error));
                    resolve(error);
                    return;
                  }
                  _this.tokenCache.save(token);
                  resolve(token);
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loginWithUsernamePassword(_x2) {
        return _loginWithUsernamePassword.apply(this, arguments);
      }
      return loginWithUsernamePassword;
    }()
    /**
     * Silently authenticates a user using an iframe.
     *
     * @param {*} opts
     */
    )
  }, {
    key: "loginWithIFrame",
    value: (function () {
      var _loginWithIFrame = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(opts) {
        var challenge, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.transactionManager.create();
            case 2:
              challenge = _context3.sent;
              _context3.next = 5;
              return silentlyRunIframe(this.apiAuth.buildAuthorizeUrl(_objectSpread(_objectSpread({}, challenge), {}, {
                responseType: 'code',
                responseMode: 'web_message',
                prompt: 'none'
              })), "https://".concat(this.domain));
            case 5:
              res = _context3.sent;
              if (!(res.code && res.state)) {
                _context3.next = 10;
                break;
              }
              _context3.next = 9;
              return this.handleRedirect(res.code, res.state);
            case 9:
              window.location.replace('/');
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loginWithIFrame(_x3) {
        return _loginWithIFrame.apply(this, arguments);
      }
      return loginWithIFrame;
    }()
    /**
     * Initiates a code exchange and retrieves a token.
     *
     * @param {*} code
     * @returns
     */
    )
  }, {
    key: "handleRedirect",
    value: (function () {
      var _handleRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(code, state) {
        var transaction, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              transaction = this.transactionManager.get();
              if (transaction) {
                _context4.next = 3;
                break;
              }
              throw new Error('No transaction was found.');
            case 3:
              if (!(transaction.state !== state)) {
                _context4.next = 5;
                break;
              }
              throw new Error('A state mismatch was detected');
            case 5:
              _context4.next = 7;
              return this.getToken({
                grant_type: 'authorization_code',
                code_verifier: transaction.verifier,
                code: code,
                redirect_uri: this.redirectUri
              });
            case 7:
              res = _context4.sent;
              this.transactionManager.clear();
              this.tokenCache.save(res);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleRedirect(_x4, _x5) {
        return _handleRedirect.apply(this, arguments);
      }
      return handleRedirect;
    }()
    /**
     * Logs out the current user and invalidates their token.
     *
     * @param {*} opts
     * @returns
     */
    )
  }, {
    key: "logout",
    value: (function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(opts) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.tokenCache.clear();
              if (!opts.localOnly) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              _context5.next = 5;
              return this.webAuth.logout(_objectSpread({}, opts));
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function logout(_x6) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
    /**
     * Retrieves the token from the cache or fetches a new token if needed.
     * If the existing token is within 60 seconds of expiration, a new token is fetched.
     *
     * @returns
     */
    )
  }, {
    key: "getTokenSilently",
    value: (function () {
      var _getTokenSilently = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var expirationWindow, cache, now, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              expirationWindow = 60;
              cache = this.tokenCache.get();
              now = Math.floor(Date.now() / 1000); // Authenticates a user silently if a previous session is detected by Auth0
              // Mainly used for impersonation and will otherwise return a login_required message
              if (cache) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return", this.loginWithIFrame());
            case 5:
              if (!(cache && cache.expires_at - expirationWindow < now)) {
                _context6.next = 19;
                break;
              }
              if (cache.refresh_token) {
                _context6.next = 9;
                break;
              }
              this.tokenCache.clear();
              return _context6.abrupt("return", this.loginWithIFrame());
            case 9:
              _context6.prev = 9;
              _context6.next = 12;
              return this.getToken({
                grant_type: 'refresh_token',
                refresh_token: cache.refresh_token,
                client_id: env.AUTH0_CLIENT_ID
              });
            case 12:
              result = _context6.sent;
              return _context6.abrupt("return", result === null || result === void 0 ? void 0 : result.access_token);
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](9);
              return _context6.abrupt("return", this.loginWithIFrame());
            case 19:
              return _context6.abrupt("return", cache === null || cache === void 0 ? void 0 : cache.access_token);
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[9, 16]]);
      }));
      function getTokenSilently() {
        return _getTokenSilently.apply(this, arguments);
      }
      return getTokenSilently;
    }()
    /**
     * Requests and caches a token from the OAuth endpoint.
     *
     * @param {*} opts
     * @returns
     */
    )
  }, {
    key: "getToken",
    value: (function () {
      var _getToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(opts) {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return axios.post("https://".concat(this.domain, "/oauth/token"), _objectSpread({
                client_id: this.clientId,
                scope: this.scope
              }, opts));
            case 2:
              result = _context7.sent;
              this.tokenCache.save(result.data);
              return _context7.abrupt("return", result.data);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getToken(_x7) {
        return _getToken.apply(this, arguments);
      }
      return getToken;
    }())
  }]);
}();
/**
 * Authenticates a user silently using an iframe.
 *
 * @param {*} authorizeUrl
 * @param {*} eventOrigin
 * @param {*} timeout
 * @returns
 */
export { Auth0Client as default };
function silentlyRunIframe(authorizeUrl, eventOrigin) {
  var _window;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
  // When a browser is running in a Cross-Origin Isolated context, using iframes is not possible.
  // It doesn't throw an error but times out instead, so we should exit early and inform the user about the reason.
  // https://developer.mozilla.org/en-US/docs/Web/API/crossOriginIsolated
  if ((_window = window) !== null && _window !== void 0 && _window.crossOriginIsolated) {
    throw new GenericError('login_required', 'The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.');
  }
  return new Promise(function (resolve, reject) {
    // Create an iFrame for silent authentication
    var iframe = window.document.createElement('iframe');
    iframe.style.display = 'none';
    var cleanUp = function cleanUp() {
      if (window.document.body.contains(iframe)) {
        window.document.body.removeChild(iframe);
        window.removeEventListener('message', iframeEventHandler, false);
      }
    };

    // Start a timeout in case the iFrame fails to load
    var timeoutSetTimeoutId = setTimeout(function () {
      reject(new TimeoutError());
      cleanUp();
    }, timeout * 1000);

    // This handler will give us a code for our challenge
    function iframeEventHandler(e) {
      if (e.origin !== eventOrigin) return;
      if (!e.data || e.data.type !== 'authorization_response') return;
      var eventSource = e.source;
      if (eventSource) {
        eventSource.close();
      }
      e.data.response.error ? reject(GenericError.fromPayload(e.data.response)) : resolve(e.data.response);
      clearTimeout(timeoutSetTimeoutId);
      window.removeEventListener('message', iframeEventHandler, false);

      // Fix for: https://github.com/auth0/auth0-spa-js/issues/240
      setTimeout(cleanUp, 2 * 1000);
    }

    // Add the iFrame and listen for a message
    window.addEventListener('message', iframeEventHandler, false);
    window.document.body.appendChild(iframe);
    iframe.src = authorizeUrl;
  });
}
//# sourceMappingURL=Auth0Client.js.map
